@if (show) {
  <!-- Backdrop -->
  <div class="banner-backdrop" (click)="dismissBackdrop()"></div>

  <!-- Bottom sheet -->
  <div class="banner-sheet" role="dialog" aria-modal="true" aria-label="Descarga la app">

    <button class="banner-close" (click)="dismissSession()" aria-label="Cerrar">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.5"
           stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="banner-body">
      <img src="/assets/isotipo-negro.png" alt="BarBook" class="banner-icon" />

      <div class="banner-text">
        <p class="banner-title">¡Lleva BarBook en tu bolsillo!</p>
        <p class="banner-subtitle">Tus bares de cualquier lugar, en un solo lugar.</p>
      </div>
    </div>

    <div class="banner-actions">
      @if (isIOS || (!isIOS && !isAndroid)) {
        <a class="store-btn ios"
           href="https://apps.apple.com/es/app/barbook-agenda-de-bares/id6740002036"
           target="_blank" rel="noopener noreferrer"
           (click)="dismissForever()">
          <img src="/assets/appstore.svg" alt="Descargar en App Store" />
        </a>
      }
      @if (isAndroid || (!isIOS && !isAndroid)) {
        <a class="store-btn android"
           href="https://play.google.com/store/apps/details?id=com.adrcanfer.barbook"
           target="_blank" rel="noopener noreferrer"
           (click)="dismissForever()">
          <img src="/assets/playstore.png" alt="Descargar en Google Play" />
        </a>
      }
    </div>

    <div class="banner-footer">
      <label class="banner-never">
        <span class="toggle-track" [class.on]="neverShow" (click)="neverShow = !neverShow">
          <span class="toggle-thumb"></span>
        </span>
        No volver a mostrar
      </label>
    </div>

  </div>
}
